import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PnldState {
  selected?: string;
}

const slice = createSlice({
  name: 'pnld',
  initialState: {} as PnldState,
  reducers: {
    setPnld(state, action: PayloadAction<string>) {
      state.selected = action.payload;
    },
  },
});

export const { setPnld } = slice.actions;
export const pnld = slice.reducer;
